import AddLoadForm from './AddLoadForm';

export default AddLoadForm;
